// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__O1KtS","loader":"Loader_loader__bAO8J","spin":"Loader_spin__Ads9M"};